import Button from "../../Button";
import NavigationClose from "../../../icons/NavigationClose";
import React from 'react';

import colors from "../../../utils/colors";
import { createStyles } from "./styles";






var CompareCard = function CompareCard(_ref) {var card = _ref.card,onRemoveFromComparison = _ref.onRemoveFromComparison;
  var classes = createStyles();
  var id = card.id,portfolioName = card.portfolioName,logoUrl = card.logoUrl;
  return /*#__PURE__*/(
    React.createElement("div", { id: "comparePortfolio_".concat(id), className: classes.cardBlock }, /*#__PURE__*/
    React.createElement("div", { className: classes.cardHeader }, /*#__PURE__*/
    React.createElement("img", { src: logoUrl, alt: portfolioName, className: classes.portfolioLogo }), /*#__PURE__*/
    React.createElement(Button, {
      type: "icon",
      color: "custom",
      customColor: colors.red[600],
      className: classes.removeButton,
      onClick: function onClick() {
        onRemoveFromComparison(id);
      } }, /*#__PURE__*/

    React.createElement(NavigationClose, null))), /*#__PURE__*/


    React.createElement("p", { className: classes.portfolioName }, portfolioName)));


};

export default CompareCard;
//# sourceMappingURL=index.js.map